import React from "react";
import { makeStyles, createStyles, theme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    main: {
      backgroundColor: "#f1f1f1",
      padding: "20px",
      float: "left",
      textAlign: "left",
      fontSize: "16px",
      fontFamily: "Times New Roman",
      color: "black",
      //   width: "60%",
    },
    heading: {
      textAlign: "center",
      fontFamily: "Times New Roman",
      fontWeight: "bold",
      color: "black",
    },
    text: { fontSize: "16px", fontFamily: "Times New Roman", color: "black" },
  })
);

export default function BilltraceCAPDisclaimerIOS() {
    const classes = useStyles();
    return (
      <>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={1} sm={2} md={2} lg={3}>
              {/* <Paper className={classes.paper}>xs=3</Paper> */}
            </Grid>
            <Grid item xs={10} sm={8} md={8} lg={6}>
              <Paper className={classes.main}>
                <h1 className={classes.heading} style={{ fontSize: 33 }}>
                  <b>Software End User Licence Agreement</b>
                </h1>
                <h2 className={classes.heading} style={{ fontSize: "23px" }}>
                  <b> "BillTrace Captain Pad" IOS Version </b>
                </h2>
                {/* <Typography className={classes.text}>
                                  Read the following terms and conditions carefully before
                                  downloading,installing or using this software (defined below).
                                  Filling in the space next to "I accept the terms in the License
                                  Agreement" indicates your acceptance of these terms and
                                  conditions. If you do not agree with such terms and
                                  conditions,click "Cancel".This Software is available only to
                                  individuals aged 13 years or older.if you are 13 or older but
                                  under the age of 18,you should review these terms and conditions
                                  with your parent or guardian to make sure that you and your
                                  parent or guardian understand these terms and conditions.
                              </Typography> */}
                <br />
                <h2 className={classes.heading} style={{ fontSize: "23px" }}>
                  LICENSE
                </h2>
                <Typography className={classes.text}>
                  Welcome to billTrace Cap, a mobile application developed by Bill
                  Trace Infotech Pvt. Ltd. This Privacy Policy explains how we
                  collect, use, and protect your personal information when you use
                  our app.
                </Typography>
                <ol>
                  <li>
                    <b>Information We Collect</b>
                    <br />
                    When you use billTrace Cap, we may collect the following types
                    of information:
                    <ul>
                      <li>
                        <b>Personal Information : </b> Name, phone number, email
                        address, and other details when you register or contact
                        us.
                      </li>
                      <li>
                        <b>Device Information : </b> Details of the orders placed
                        through the app.
                      </li>
                      <li>
                        <b>Usage Data : </b> IP address, device model, operating
                        system, and app usage data.
                      </li>
                      <li>
                        <b>Location Data (if applicable): </b> If enabled, we may
                        collect your location to improve service efficiency.
                      </li>
                    </ul>
                  </li>
                  <br />
                  <li>
                    <b>How We Use the Information</b>
                    <br />
                    We use your information to:
                    <ul>
                      <li>
                        Process and manage customer orders in hotels/restaurants.
                      </li>
                      <li>Improve app functionality and user experience.</li>
                      <li>Provide customer support and respond to inquiries.</li>
                      <li>Ensure security and prevent fraud.</li>
                      <li>Comply with legal obligations.</li>
                    </ul>
                  </li>
                  <br />
                  <li>
                    <b>Sharing of Information :</b>
                    <br />
                    We do not sell or rent your personal data. We may share
                    information with:
                    <ul>
                      <li>
                        <b>Restaurants/Hotels : </b> To process and fulfill your
                        order.
                      </li>
                      <li>
                        <b>Service Providers : </b> Third-party vendors assisting
                        in app functionality, payments, or analytics.
                      </li>
                      <li>
                        <b>Legal Authorities : </b> If required by law or to
                        protect our rights and security.
                      </li>
                    </ul>
                  </li>
                  <br />
                  <li>
                    <b>Data Security : </b>
                    <br />
                    We implement industry-standard security measures to protect
                    your data from unauthorized access, disclosure, or misuse.
                    However, no system is 100% secure.
                  </li>
                  <br />
                  <li>
                    <b>User Rights : </b>
                    <br />
                    You have the right to:
                    <ul>
                      <li>
                        Access, update, or delete your personal information.
                      </li>
                      <li>
                        Withdraw consent for data processing (where applicable).
                      </li>
                      <li>Contact us for any privacy-related concerns.</li>
                    </ul>
                  </li>
                  <br />
                  <li>
                    <b>Third-Party Services : </b> <br />
                    The app may contain links to third-party services (e.g.,
                    payment gateways). We are not responsible for their privacy
                    practices, and we encourage users to review their policies.
                  </li>
                  <br />
                  <li>
                    <b>Children's Privacy : </b> <br />
                    billTrace Cap is not intended for children under 13. We do not
                    knowingly collect data from minors.
                  </li>
                  <br />
                  <li>
                    <b>Changes to this Privacy Policy : </b> <br />
                    We may update this policy periodically. Any significant changes will be notified through the app or our website.
                  </li>
                  <br />
                  <li>
                    <b>Contact Us : </b>
                    <br />
                    If you have any questions or concerns regarding this Privacy Policy, please contact us at: <b></b>
                    <ul>
                      <li>
                        <b>Company Name: </b> Bill Trace Infotech Pvt. Ltd.
                      </li>
                      <li>
                        <b>Email: </b> billtraceinfotech@gmail.com
                      </li>
                      <li>
                        <b>Website:</b>{" "}
                        <a href={"billtraceinfotech.com"}>billtraceinfotech.com</a>
                      </li>
                    </ul>
                  </li>
                  <br />
                </ol>
              </Paper>
            </Grid>
            <Grid item xs={1} sm={2} md={2} lg={3}>
              {/* <Paper className={classes.paper}>xs=3</Paper> */}
            </Grid>
          </Grid>
        </div>
      </>
    );
}
